import {uploadFileToS3} from '@sollapay/web-core';

import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  AvatarUploadUrlDTO,
  AvatarUploadUrlPayload,
  UpdateUserProfilePayload,
  UserProfileDTO
} from '@sollapay/types';

export const accountSettingsApi = {
  fetchProfile: async (client: HttpClient): Promise<ApiResponse<UserProfileDTO>> =>
    client.get<ApiResponse<UserProfileDTO>>('/user/profile'),

  updateProfile: async (
    client: HttpClient,
    payload: UpdateUserProfilePayload
  ): Promise<ApiResponse<UserProfileDTO>> =>
    client.patch<ApiResponse<UserProfileDTO>, UpdateUserProfilePayload>('/user/profile', payload),

  createAvatarUploadUrl: async (
    client: HttpClient,
    payload: AvatarUploadUrlPayload
  ): Promise<ApiResponse<AvatarUploadUrlDTO>> =>
    client.post<ApiResponse<AvatarUploadUrlDTO>, AvatarUploadUrlPayload>(
      '/user/avatar/upload-url',
      payload
    ),

  uploadAvatarToS3: uploadFileToS3
};
